import Papa from 'papaparse';
import Notification from '../Components/Layout/Notification';

interface UserRecord {
  id: number;
  login: string;
  firstName: string;
  lastName: string;
  email: string;
  activated: boolean;
  langKey: string;
  authorities: string[];
  tenant: { id: number; name: string; tenantKey: string };
  generatedPassword?: string;
  createdBy?: string;
  createdDate?: string;
  lastModifiedBy?: string;
  lastModifiedDate?: string;
  activationKey?: string;
  resetKey?: string;
  resetDate?: string;
}

interface TenantRecord {
  id: number;
  name: string;
  tenantKey: string;
}

interface RoleRecord {
  id: number;
  name: string;
}

type DataType = 'user' | 'tenant' | 'role';

const processDataForCsv = (
  data: UserRecord[] | TenantRecord[] | RoleRecord[],
  dataType: DataType
): Record<string, unknown>[] => {
  if (dataType === 'user') {
    return (data as UserRecord[]).map(user => {
      const tenant = user.tenant;
      return {
        ID: user.id,
        Login: user.login,
        'First Name': user.firstName,
        'Last Name': user.lastName,
        Email: user.email,
        Activated: user.activated,
        'Language Key': user.langKey,
        Authorities: user.authorities.join(', '),
        'Tenant ID': tenant.id,
        'Tenant Name': tenant.name,
        'Tenant Key': tenant.tenantKey,
        'Generated Password': user.generatedPassword,
        'Created By': user.createdBy,
        'Created Date': user.createdDate,
        'Last Modified By': user.lastModifiedBy,
        'Last Modified Date': user.lastModifiedDate,
        'Activation Key': user.activationKey,
        'Reset Key': user.resetKey,
        'Reset Date': user.resetDate,
      };
    });
  } else if (dataType === 'tenant') {
    return (data as TenantRecord[]).map(tenant => ({
      ID: tenant.id,
      Name: tenant.name,
      'Tenant Key': tenant.tenantKey,
    }));
  } else {
    return (data as RoleRecord[]).map(role => ({
      ID: role.id,
      Name: role.name,
    }));
  }
};

export const createCsv = async (
  data: UserRecord[] | TenantRecord[] | RoleRecord[],
  dataType: DataType
): Promise<Blob | undefined> => {
  try {
    const csvData = processDataForCsv(data, dataType);
    const csv = Papa.unparse(csvData);
    const file = new Blob([csv], { type: 'text/csv;charset=utf-8' });
    Notification.showSuccess(`Your file is ready.`);
    return file;
  } catch {
    Notification.showError('Processing file error. Please try again.');
  }
};
